<template>
  <div>
    <div>
      <!-- Loader while waiting -->
      <v-skeleton-loader
        tile
        v-if="fetchLoader"
        type="table-tbody,table-tfoot"
        class="mt-3"
        :class="
          isExtension
            ? 'table-width-extension'
            : $vuetify.breakpoint.md
            ? 'table-width-2'
            : $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
            ? 'table-width-3'
            : getSidebarMini
            ? 'table-width-4'
            : 'table-width'
        "
      >
      </v-skeleton-loader>
      <!-- Data Table, will render data on receiving respective props from (parent)IP Security Panel-->
      <v-data-table
        v-else
        :headers="headers"
        :items="getIps"
        item-key="ip_label"
        :loading="fetchLinearLoader"
        loading-text="No data available"
        v-model="selected"
        hide-default-footer
        :items-per-page="perPage"
        :page="currentPage"
        @pagination="updatePagination"
        show-select
        class="elevation-0 table-border mb-1 mt-4 ips-table"
        :height="
          $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
            ? 'calc(100vh - 425px)'
            : 'calc(100vh - 340px)'
        "
        id="allowed-ips-table"
        fixed-header
        :class="[
          { edited_scrollbar: isMac },
          $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
            ? 'mx-3 ipList-table-height-sm'
            : 'ml-3',
        ]"
        :mobile-breakpoint="0"
      >
        <template v-slot:[`header.ip_label`]="{ header }">
          <div class="dark-purple-text">
            {{ header.text }}
          </div>
        </template>
        <template v-slot:[`header.ip_address`]="{ header }">
          <div class="dark-purple-text">
            {{ header.text }}
          </div>
        </template>
        <template v-slot:[`header.actions`]="{ header }">
          <div class="dark-purple-text">
            {{ header.text }}
          </div>
        </template>
        <v-progress-linear
          v-show="fetchLinearLoader"
          slot="progress"
          color="#2a206a"
          indeterminate
        ></v-progress-linear>

        <template v-slot:[`body.prepend`]="{ headers }">
          <tr>
            <td v-for="(header, i) in headers" :key="i">
              <div v-if="header.value == 'ip_address'" class="sub-header">
                <div class="inputContainer">
                  <v-icon small class="ml-1 mt-3"> mdi-magnify </v-icon>
                  <input
                    autocomplete="off"
                    v-model="searchedIp"
                    type="text"
                    size="15"
                    @keydown.enter="searchSelectedIP()"
                    id="ip-search"
                    class="header-search-input-field mb-1 mt-2 rounded-2"
                    placeholder="Search ..."
                  />
                </div>
              </div>
              <div v-if="header.value == 'ip_label'" class="sub-header">
                <div class="inputContainer">
                  <v-icon small class="ml-1 mt-3"> mdi-magnify </v-icon>
                  <input
                    autocomplete="off"
                    v-model="searchedlabel"
                    @keydown.enter="searchSelectedLabel()"
                    type="text"
                    size="15"
                    id="ip-label-search"
                    class="header-search-input-field mb-1 mt-2 rounded-2"
                    placeholder="Search ..."
                  />
                </div>
              </div>
            </td>
          </tr>
        </template>

        <template v-slot:[`item.ip_label`]="{ item }">
          <v-hover v-slot="{ hover }">
            <div
              :style="isExtension ? 'max-width: 220px' : 'max-width: 230px'"
              class="d-flex d-inline-block align-center pr-7"
              :id="'label-' + item.id"
            >
              <v-icon
                @click.stop="
                  selectIpAddress(item);
                  ipLabel = item.ip_label;
                "
                v-show="hover && !ipLabel"
                size="14"
                >mdi-pencil</v-icon
              >
              <v-text-field
                autocomplete="off"
                autofocus
                v-model="ipLabel"
                outlined
                dense
                hide-details=""
                color="#2a206a"
                placeholder="Add Title"
                v-if="selectedIP && selectedIP.id == item.id"
                @click.stop=""
                @keydown.enter="editLabel(item)"
                @blur="(selectedIP = null), (ipLabel = null)"
                @keydown.esc="(selectedIP = null), (ipLabel = null)"
              >
                <template v-slot:append>
                  <v-icon color="green" @click.stop="editLabel(item)">
                    mdi-check
                  </v-icon>
                </template>
              </v-text-field>
              <p
                v-else
                :style="isExtension ? 'max-width: 220px' : 'max-width: 230px'"
                :class="[{ 'thin red--text font-italic': !item.ip_label }]"
                class="d-flex align-center body-2 w-100 ml-2 ma-0 pointer"
              >
                <v-tooltip
                  :disabled="$vuetify.breakpoint.xs"
                  bottom
                  content-class="arrow-up"
                  color="#DCD8F3"
                >
                  <template v-slot:activator="{ on }">
                    <span
                      style="max-width: 150px"
                      class="d-inline-block text-truncate"
                      v-on="on"
                    >
                      {{ item.ip_label ? item.ip_label : "No Label" }}
                    </span>
                  </template>
                  <span
                    class="d-inline-block text-capitalize font-weight-bold dark-purple-text"
                    :style="
                      $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                        ? 'max-width: 150px;word-wrap:break-word;'
                        : 'max-width:300px;word-wrap:break-word;'
                    "
                  >
                    {{ item.ip_label ? item.ip_label : "No Label" }}</span
                  >
                </v-tooltip>
              </p>
            </div>
          </v-hover>
        </template>
        <!-- Actions Field -->
        <!-- This custome slot will render data(actions culumn) into the table -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex">
            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              bottom
              content-class="arrow-up"
              color="#DCD8F3"
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  :small="activeTab == 'Allowed'"
                  :color="activeTab == 'Allowed' ? 'red' : '#1cc283'"
                  @click="changeIpAccessFunc(item)"
                  v-on="on"
                >
                  {{
                    activeTab == "Allowed"
                      ? "mdi-block-helper"
                      : "mdi-checkbox-multiple-marked-circle"
                  }}
                </v-icon>
              </template>
              <span class="font-weight-bold dark-purple-text">
                {{ activeTab == "Allowed" ? "Block IP" : "Allow IP" }}
              </span>
            </v-tooltip>

            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              bottom
              content-class="arrow-up"
              color="#DCD8F3"
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  color="#2a206a"
                  class="ml-3 mt-n1"
                  @click="removeIp(item.id)"
                  v-on="on"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span class="font-weight-bold dark-purple-text"> Delete </span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>

      <!-- Pagination -->
      <div
        class="d-flex w-100 align-center"
        :class="[$vuetify.breakpoint.xs ? 'flex-column' : 'px-4']"
      >
        <div
          v-if="!$vuetify.breakpoint.xs"
          class="d-flex w-100 my-1 align-center"
        >
          <span class="ml-2 pagination-text-color d-flex align-center">
            View:
          </span>
          <!-- hidden on sm screens -->
          <div
            :style="
              isExtension
                ? 'width: 65px'
                : $vuetify.breakpoint.xs
                ? 'width: 85px;'
                : 'width: 82px;'
            "
            class="pa-0 d-none d-sm-flex mx-1"
            style="width: 95%"
            :cols="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? 2 : 1"
          >
            <v-select
              id="reports-pg-selector"
              style="display: inline-table"
              hide-details
              dense
              solo
              flat
              class="subtitle-2 px-n2"
              :items="[5, 10, 25, 50, 100]"
              v-model="perPage"
            />
          </div>
          <!-- hidden on sm-screens -->
          <span
            class="d-none d-sm-flex pagination-text-color"
            :class="
              $vuetify.breakpoint.xs ? 'subtitle-2 my-2 ' : 'd-flex align-end'
            "
            >rows per page</span
          >
        </div>
        <v-spacer></v-spacer>
        <div
          :class="
            $vuetify.breakpoint.xs ? 'flex-column flex-column-reverse' : ''
          "
          class="d-flex justify-end align-center w-100 body-2 dusty-purple-text"
        >
          <span
            :class="
              $vuetify.breakpoint.xs
                ? ' d-flex justify-center w-100 my-2 mx-1'
                : ''
            "
            class="my-1 pagination-text-color"
          >
            Showing
            {{ pageStart ? pageStart : 1 }}-{{ pageStop ? pageStop : 1 }}
            of
            {{ itemsLength }}
            {{ $vuetify.breakpoint.xs ? "" : "entries" }}
          </span>

          <v-pagination
            id="pagination"
            color="#302277"
            v-model="currentPage"
            :length="pageCount"
            circle
            :total-visible="5"
          ></v-pagination>
          <span
            v-show="
              $vuetify.breakpoint.md ||
              $vuetify.breakpoint.lg ||
              $vuetify.breakpoint.xl
            "
          >
            Go to:
            <input
              v-model="pageInput"
              @keydown.enter="goToPage"
              type="number"
              class="pagination-input pl-2 ml-2 mr-0 rounded-sm"
            />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import _ from "lodash";
export default {
  props: ["activeTab"],
  data() {
    return {
      // myItems: this.items,
      currentPage: 1,
      perPage: 25,
      pageCount: 1,
      pageStart: 1,
      pageInput: 1,
      pageStop: 25,
      itemsLength: 25,
      currentTab: "Active",
      searchedIp: null,
      searchedlabel: null,
      selected: [],
      selectedIP: null,
      ipLabel: null,
      fetchLinearLoader: false,
      // Header for the table, will render respective data after receiving props from the parent
      headers: [
        {
          text: "Label",
          value: "ip_label",
          sortable: false,
          cellClass: "px-0",
        },
        {
          text: "IP Address",
          value: "ip_address",
          sortable: false,
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getIps: "getIps",
      fetchLoader: "getFetchIpLoader",
      getSidebarMini: "getSidebarMini",
      getIpAddress: "getIpAddress",
    }),
  },
  methods: {
    updatePagination(value) {
      if (value) {
        this.pageInput = value.page;
        this.currentPage = value.page;
        this.pageStart = value.pageStart;
        this.pageStop = value.pageStop;
        this.pageCount = value.pageCount;
        this.itemsLength = value.itemsLength;
      }
    },
    goToPage() {
      if (
        parseInt(this.pageInput) > 0 &&
        parseInt(this.pageInput) <= this.pageCount
      )
        this.currentPage = parseInt(this.pageInput);
    },
    changeIpAccessFunc(ipObj) {
      let data = {
        address_id: ipObj.id,
        ip_label: ipObj.ip_label,
        ip_address: ipObj.ip_address,
        allowed: this.activeTab == "Allowed" ? false : true,
      };
      this.$store.dispatch("updateIPAccessStatus", data).then(() => {
        this.$emit("showSnackbar", {
          message:
            this.activeTab == "Allowed"
              ? "IP Address Blocked Successfully"
              : "IP Address Allowed Successfully",
          error: false,
        });
      });
    },
    removeIp(id) {
      Swal.fire({
        title: "Are you sure?",
        html: "Delete this IP Address!",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonText: "Delete",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("deleteIp", [id]).then(() => {
            this.$emit("showSnackbar", {
              message: "IP Address Deleted Successfully",
              error: false,
            });
          });
        }
      });
    },
    searchSelectedIP() {
      this.fetchLinearLoader = true;
      this.$store.commit("setIpFilter", { ip_address: this.searchedIp });
      this.$store.dispatch("fetchIps").then(() => {
        this.fetchLinearLoader = false;
      });
    },
    searchSelectedLabel() {
      this.fetchLinearLoader = true;
      this.$store.commit("setIpFilter", { ip_label: this.searchedlabel });
      this.$store.dispatch("fetchIps").then(() => {
        this.fetchLinearLoader = false;
      });
    },
    selectIpAddress(ip) {
      this.selectedIP = ip;
    },
    editLabel(data) {
      let oldLabel = data.ip_label;
      let trimLabel = this.ipLabel.trim();
      if (trimLabel.length > 0) {
        let body = {
          address_id: data.id,
          ip_label: trimLabel,
          ip_address: data.ip_address,
          allowed: data.allowed,
        };
        this.$store.commit("setUpdatedLabel", {
          ip: this.getIpAddress(data.id),
          ip_label: trimLabel,
        });

        this.$store
          .dispatch("updateIPLabel", body)
          .then(() => {
            this.$emit("showSnackbar", {
              message: "Label Updated Successfully",
              error: false,
            });
          })
          .catch((error) => {
            this.$store.commit("setUpdatedLabel", {
              ip: this.getIpAddress(data.id),
              ip_label: oldLabel,
            });
            this.$emit("showSnackbar", {
              message: error.response.data.errors.ip_label[0],
              error: true,
            });
          });
        this.selectedIP = null;
        this.ipLabel = null;
      }
    },
  },
  watch: {
    selected(value) {
      if (value && this.selected.length > 1) {
        eventBus.$emit("multipleSelected", true);
      } else {
        eventBus.$emit("multipleSelected", false);
      }
    },
    searchedIp: {
      handler: _.debounce(function () {
        this.fetchLinearLoader = true;
        this.$store.commit("setIpFilter", { ip_address: this.searchedIp });
        this.$store.dispatch("fetchIps").then(() => {
          this.fetchLinearLoader = false;
        });
      }, 1000),
      deep: true,
    },
    searchedlabel: {
      handler: _.debounce(function () {
        this.fetchLinearLoader = true;
        this.$store.commit("setIpFilter", { ip_label: this.searchedlabel });
        this.$store.dispatch("fetchIps").then(() => {
          this.fetchLinearLoader = false;
        });
      }, 1000),
      deep: true,
    },
  },
  mounted() {
    eventBus.$on("deleteMultipleSelected", () => {
      let selectedIpsId = [];
      for (let index of this.selected) {
        selectedIpsId.push(index.id);
      }
      this.$store.dispatch("deleteIp", selectedIpsId).then(() => {
        this.$emit("showSnackbar", {
          message: "Selected IP Addresses Deleted Successfully",
          error: false,
        });
      });
    });
    eventBus.$on("setSwitchBtn", () => {
      this.searchedIp = null;
      this.searchedlabel = null;
    });
    eventBus.$on("changeCompanyPolicy", () => {
      this.searchedIp = null;
      this.searchedlabel = null;
    });
  },
  beforeDestroy() {
    eventBus.$off("deleteMultipleSelected");
    eventBus.$off("changeCompanyPolicy");
    eventBus.$off("setSwitchBtn");
  },
};
</script>
<style scoped>
.inputContainer i {
  position: absolute;
}
.header-search-input-field {
  border: 1px #dad6f5 solid;
  border-radius: 2px;
  height: 22px;
  font-weight: lighter;
  padding-left: 20px;
}
.header-search-input-field::placeholder {
  color: grey !important;
  font-size: 13px;
}
.v-progress-linear {
  background: transparent;
  overflow: hidden;
  position: initial;
  transition: 0.2s cubic-bezier(0.4, 0, 0.6, 1);
  width: 100%;
}
</style>
<style>
.ips-table thead th {
  background-color: #edebf9 !important;
  color: #2a206a !important;
}
</style>
